export default __webpack_public_path__ + "static/media/logo_MW.3d5b30fd.png";